import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { vehicleApi } from '../services/api';
import CommenCarSlider from '../element/CommenCarSlider';
import ContectUs from '../components/ContectUs';
import { IMAGE } from '../constent/theme';

const SocialMediaLinks = () => {
    return (
        <ul className="d-flex gap-3 list-unstyled mb-0">
            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f text-primary" style={{ fontSize: '20px' }}></i></a></li>
            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter text-info" style={{ fontSize: '20px' }}></i></a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in text-primary" style={{ fontSize: '20px' }}></i></a></li>
            <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram text-danger" style={{ fontSize: '20px' }}></i></a></li>
        </ul>
    );
};

const VehicleFeatureGrid = ({ vehicle }) => {
    const getYear = (dateStr) => {
        if (!dateStr) return 'N/A';
        try {
            return new Date(dateStr).getFullYear();
        } catch {
            return 'N/A';
        }
    };

    const features = [
        {
            iconClass: 'fa fa-calendar-alt text-primary mb-2',
            heading: getYear(vehicle.first_registration_date || vehicle.manufacturing_date),
            text: "Année d'immat."
        },
        {
            iconClass: 'fa fa-tachometer-alt text-primary mb-2',
            heading: vehicle.mileage ? `${vehicle.mileage.toLocaleString()} km` : 'N/A',
            text: 'Kilométrage'
        },
        {
            iconClass: 'fa fa-gas-pump text-primary mb-2',
            heading: vehicle.fuel_type_name || 'N/A',
            text: 'Carburant'
        },
        {
            iconClass: 'fa fa-cog text-primary mb-2',
            heading: vehicle.transmission_name || 'N/A',
            text: 'Transmission'
        },
        {
            iconClass: 'fa fa-car text-primary mb-2',
            heading: vehicle.body_style_name || 'N/A',
            text: 'Carrosserie'
        },
        {
            iconClass: 'fa fa-paint-brush text-primary mb-2',
            heading: vehicle.exterior_color || 'N/A',
            text: 'Couleur'
        }
    ];

    return (
        <div className="used-car-features m-b30">
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                border: '1px solid #eee',
                borderRadius: '8px',
                overflow: 'hidden',
            }}>
                {features.map((item, idx) => (
                        <div
                            className="car-feature-box"
                            key={idx}
                            style={{
                                padding: '16px 12px',
                                textAlign: 'center',
                                borderRight: idx % 3 !== 2 ? '1px solid #eee' : 'none',
                                borderBottom: idx < 3 ? '1px solid #eee' : 'none',
                                background: '#fff',
                            }}
                        >
                            <i className={item.iconClass} style={{ fontSize: '22px', display: 'block', margin: '0 auto' }}></i>
                            <h6 className="mt-2 mb-1" style={{ fontSize: '14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{item.heading}</h6>
                            <span className="text-muted" style={{ fontSize: '13px', wordBreak: 'break-word' }}>{item.text}</span>
                        </div>
                    ))}
                </div>
            </div>
    );
};

const CarDetail_1 = () => {
    const { id } = useParams();
    const [vehicle, setVehicle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [addActive, setActive] = useState('nav_one');

    useEffect(() => {
        const loadVehicle = async () => {
            setLoading(true);
            try {
                const response = await vehicleApi.getById(id);
                setVehicle(response.data);
            } catch (error) {
                console.error('Error loading vehicle:', error);
            } finally {
                setLoading(false);
            }
        };
        loadVehicle();
        window.scrollTo({ top: 0 });
    }, [id]);

    const navLinks = (e) => {
        e.preventDefault();
        setActive(e.currentTarget.id);
    };

    if (loading) {
        return (
            <div className="page-content bg-white">
                <div className="container py-5 text-center">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-3">Loading vehicle details...</p>
                </div>
            </div>
        );
    }

    if (!vehicle) {
        return (
            <div className="page-content bg-white">
                <div className="container py-5 text-center">
                    <h3>Vehicle not found</h3>
                    <Link to="/cars" className="btn btn-primary mt-3">Back to Cars</Link>
                </div>
            </div>
        );
    }

    const slides = vehicle.images && vehicle.images.length > 0
        ? vehicle.images.map(img => ({ img: img.url, thumb: img.url }))
        : [
            { img: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?q=80&w=800&auto=format&fit=crop', thumb: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?q=80&w=800&auto=format&fit=crop' }
        ];

    return (
        <div className="page-content bg-white">
            <nav aria-label="breadcrumb" className="breadcrumb-row">
                <div className="container">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item"><Link to="/cars">Car Collections</Link></li>
                        <li className="breadcrumb-item active">{vehicle.manufacturer_name} {vehicle.model}</li>
                    </ul>
                </div>
            </nav>

            <section className="content-inner-2">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7 col-md-6 m-b0 m-md-b50">
                            <div className="product-gallery on-show-slider lightgallery m-b40" id="lightgallery">
                                <Swiper 
                                    className="swiper-container sync1"
                                    spaceBetween={10}
                                    speed={1200}
                                    thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                >
                                    {slides.map((slide, index) => (
                                        <SwiperSlide className="swiper-slide" key={index}>
                                            <div className="dlab-thum-bx" style={{ overflow: 'hidden', borderRadius: '8px' }}>
                                                <img 
                                                    src={slide.img} 
                                                    alt={vehicle.model} 
                                                    style={{ width: '100%', height: '450px', objectFit: 'cover' }} 
                                                    onError={(e) => { e.target.onerror = null; e.target.src = IMAGE.productPic1; }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                                <Swiper 
                                    className="swiper-container thumb-slider sync2"
                                    onSwiper={setThumbsSwiper}
                                    spaceBetween={15}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    style={{ marginTop: '15px' }}
                                    breakpoints={{
                                        1200: { slidesPerView: 4 },
                                        780: { slidesPerView: 4 },
                                        300: { slidesPerView: 3 },
                                    }}
                                >
                                    {slides.map((item, ind) => (
                                        <SwiperSlide id="thumbsSlides" className="swiper-slide slidethumbs" key={ind}>
                                            <div className="dlab-media" style={{ height: '80px', borderRadius: '4px', overflow: 'hidden', cursor: 'pointer' }}>
                                                <img 
                                                    className="cursorPointer" 
                                                    src={item.thumb} 
                                                    alt="" 
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                                    onError={(e) => { e.target.onerror = null; e.target.src = IMAGE.productPic1; }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>

                            <div className="m-b50">
                                <div className="dlab-post-title">
                                    <h3 className="post-title">
                                        <Link to="#">{vehicle.manufacturer_name} {vehicle.model}</Link>
                                    </h3>
                                    <h6 className="sub-title">{vehicle.submodel || 'Vehicle'}</h6>
                                    {vehicle.description && (
                                        <div className="m-b10 mt-3">
                                            <div 
                                                style={{ 
                                                    whiteSpace: 'pre-line', 
                                                    maxHeight: isDescriptionExpanded ? 'none' : '120px', 
                                                    overflow: 'hidden',
                                                    position: 'relative'
                                                }}
                                            >
                                                <div dangerouslySetInnerHTML={{ __html: vehicle.description.replace(/\n/g, '<br />') }} />
                                                {!isDescriptionExpanded && vehicle.description.length > 200 && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        bottom: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: '50px',
                                                        background: 'linear-gradient(transparent, white)'
                                                    }}></div>
                                                )}
                                            </div>
                                            {vehicle.description.length > 200 && (
                                                <div className="text-end mt-1">
                                                    <button 
                                                        className="btn btn-sm btn-link p-0 text-primary" 
                                                        onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                                                        style={{ textDecoration: 'none', fontSize: '0.85rem' }}
                                                    >
                                                        {isDescriptionExpanded ? 'Lire moins' : 'Lire la suite'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className="dlab-divider bg-gray tb15">
                                        <i className="icon-dot c-square"></i>
                                    </div>
                                </div>
                                <div className="social-list d-flex align-items-center gap-3">
                                    <span>Partager:</span>
                                    <SocialMediaLinks />
                                </div>
                            </div>

                            <div className="product-description">
                                <ul className="nav nav-tabs style-1 m-b20">
                                    <li><Link to="#" id='nav_one' onClick={navLinks} className={`nav-link ${addActive === 'nav_one' ? 'active' : ''}`}>Fiche technique</Link></li>
                                    <li><Link to="#" id='nav_two' onClick={navLinks} className={`nav-link ${addActive === 'nav_two' ? 'active' : ''}`}>Détails du véhicule</Link></li>
                                    <li><Link to="#" id='nav_three' onClick={navLinks} className={`nav-link ${addActive === 'nav_three' ? 'active' : ''}`}>Options & Équipements</Link></li>
                                </ul>
                                <div className="tab-content">
                                    <div id="specifications" className={`tab-pane ${addActive === 'nav_one' ? 'active' : ''}`}>
                                        <div className="icon-bx-wraper bx-style-1 p-a30 p-sm-a15">
                                            <ul className="table-dl clearfix mb-0">
                                                <li>
                                                    <div className="leftview">Kilométrage</div>
                                                    <div className="rightview">{vehicle.mileage ? `${vehicle.mileage.toLocaleString()} km` : 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Type de carburant</div>
                                                    <div className="rightview">{vehicle.fuel_type_name || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Transmission</div>
                                                    <div className="rightview">{vehicle.transmission_name || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Cylindrée</div>
                                                    <div className="rightview">{vehicle.cylinder_capacity ? `${vehicle.cylinder_capacity} cc` : 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Puissance</div>
                                                    <div className="rightview">{vehicle.engine_power_hp ? `${vehicle.engine_power_hp} CH` : 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Carrosserie</div>
                                                    <div className="rightview">{vehicle.body_style_name || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Couleur extérieure</div>
                                                    <div className="rightview">{vehicle.exterior_color || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Type de peinture</div>
                                                    <div className="rightview">{vehicle.paint_type || 'N/A'}</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div id="presentation" className={`tab-pane ${addActive === 'nav_two' ? 'active' : ''}`}>
                                        <div className="icon-bx-wraper bx-style-1 p-a30 p-sm-a15">
                                            <ul className="table-dl clearfix mb-0">
                                                <li>
                                                    <div className="leftview">N° de châssis (VIN)</div>
                                                    <div className="rightview">{vehicle.vin || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Code de référence</div>
                                                    <div className="rightview">{vehicle.cipher}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Catégorie</div>
                                                    <div className="rightview">{vehicle.category_name || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Première immatriculation</div>
                                                    <div className="rightview">{vehicle.first_registration_date ? new Date(vehicle.first_registration_date).toLocaleDateString() : 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Date de fabrication</div>
                                                    <div className="rightview">{vehicle.manufacturing_date ? new Date(vehicle.manufacturing_date).toLocaleDateString() : 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">État du véhicule</div>
                                                    <div className="rightview">{vehicle.usage_category_name || 'N/A'}</div>
                                                </li>
                                                <li>
                                                    <div className="leftview">Historique d'accidents</div>
                                                    <div className="rightview">{vehicle.accident_flag === 'Y' ? 'Accidenté' : 'Non accidenté'}</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div id="features" className={`tab-pane ${addActive === 'nav_three' ? 'active' : ''}`}>
                                        <div className="icon-bx-wraper bx-style-1 p-a30 p-sm-a15">
                                            {vehicle.options && vehicle.options.length > 0 ? (
                                                <ul className="row list-unstyled mb-0">
                                                    {vehicle.options.map((opt, index) => (
                                                        <li key={index} className="col-md-6 mb-3 d-flex align-items-center">
                                                            <i className="fa fa-check text-success me-2" style={{ fontSize: '16px' }}></i>
                                                            <span>{opt.option_name} {opt.value && opt.value !== '1' && `(${opt.value})`}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="mb-0 text-muted">Aucune option spécifique répertoriée. Les options standard du constructeur s'appliquent.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-5 col-md-6">
                            <div className="sticky-top nav-tabs-top">
                                <VehicleFeatureGrid vehicle={vehicle} />
                                <div className="car-dl-info icon-bx-wraper style-1 m-b50">
                                    <div className="price m-b30">
                                        <h3 className="mb-1">€{vehicle.gross_price?.toLocaleString()}</h3>
                                        <span className="text-muted d-block">
                                            Net : €{vehicle.net_price?.toLocaleString()}{vehicle.tax_rate ? ` (Hors ${vehicle.tax_rate * 100}% TVA)` : ' (TVA non applicable)'}
                                        </span>
                                    </div>
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <p className="text-muted">Contactez-nous pour obtenir plus de détails ou planifier un essai.</p>
                                        <div className="form-group mb-3">
                                            <input type="text" className="form-control sm" placeholder="Votre nom" required />
                                        </div>
                                        <div className="form-group mb-3">
                                            <input type="email" className="form-control sm" placeholder="Adresse e-mail" required />
                                        </div>
                                        <div className="form-group mb-3">
                                            <input type="tel" className="form-control sm" placeholder="Numéro de téléphone" required />
                                        </div>
                                        <div className="form-group mb-3">
                                            <textarea className="form-control sm" placeholder="Je suis intéressé par ce véhicule..." rows="3" style={{ border: '1px solid #eee' }}></textarea>
                                        </div>
                                        <div className="clearfix">
                                            <button type="submit" className="btn-primary btn btn-block w-100">Envoyer la demande</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CommenCarSlider title={"POUR UN APERÇU RAPIDE"} />

            <section className="content-inner">
                <div className="container">
                    <ContectUs />
                </div>
            </section>
        </div>
    );
};

export default CarDetail_1;